import { FaClock, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';


export default function InfoSection(){
    return(
      <div className="container section bg-white  rounded py-4 mt-5">
      <div className="row text-center align-items-center">
        <div className="col-md-4 d-flex flex-column align-items-center" >
        <div className="icon-circle  mb-2 ">
            <FaClock color="white" />
          </div>
          <ul className="opening-times">
          <li><strong>Mon-Thur: </strong>  11:00am - 9:30pm</li>
              <li><strong>Fri-Sat:</strong> 9:30am - 10:00pm</li>
              <li><strong>Sunday:</strong> 9:30am - 9:30pm</li>
          </ul>          <small className="text-muted">Open hours</small>
        </div>

        <div className="col-md-4 d-flex flex-column align-items-center border-left border-right">
          <div className="icon-circle  mb-2 mt-4">
            <FaMapMarkerAlt color="white" />
          </div>
          <h6 className="font-weight-bold mb-0">
  <a
    href="https://www.google.com/maps?q=815+E+78th+St,+Minneapolis,+MN+55420"
    target="_blank"
    rel="noopener noreferrer"
    className="text-decoration-none text-dark"
  >
      2960 Shallowford Rd # 311, Marietta, GA 30066
  </a>
</h6>

          <small className="text-muted">Find us</small>
        </div>

        <div className="col-md-4 d-flex flex-column align-items-center">
          <div className="icon-circle  mb-2 mt-4">
            <FaPhone color="white" />
          </div>
          <a href='tel:7636006270' >
          <h6 className="font-weight-bold mb-0">763-600-6270

</h6>
</a>
          <small className="text-muted">Call us</small>
        </div>
      </div>
    </div>
    )
}
